import { MessageId } from "Constants/languages"
import { DepositFormValues } from "./DepositForm.types"

export const initialValues: DepositFormValues = { amount: "" }

export const accountTitles: Record<string, MessageId> = {
  savings: "app.common.account.savingsAccount",
}
